import React from "react"
import './dealershipLoader.scss';

export const DealershipLoader = (props: any) => (
  <svg
    className='spin'
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path d="M22.5 12C22.5 6.47715 18.0228 2 12.5 2" stroke="#EAEAEA" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2"
      stroke="#064B87"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
)
